import firebase from 'firebase';
import { FireSQL } from 'firesql';
require("firebase/firestore");

var config = {
    apiKey: "AIzaSyAjoL_YsPfZrkUI86abS_L-bnOQbpN46dA",
    authDomain: "murilo-a7f0d.firebaseapp.com",
    projectId: "murilo-a7f0d",
    storageBucket: "murilo-a7f0d.appspot.com",
    messagingSenderId: "788477227157",
    appId: "1:788477227157:web:b16d241f1a6c4815502b9c"
};

if (!firebase.apps.length) {
    firebase.initializeApp(config);
    // firebase.analytics();
}

export const db = firebase.firestore();
export const fireSQL = new FireSQL(db);
export const firebaseAuth = firebase.auth;
export const firebaseNow = () => firebase.firestore.Timestamp.fromDate(new Date());


